import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { WorkOrder } from './work-order';
import { ReservationService } from '@app/_components/reservation';
import { PropertyService } from '@app/_components/property/property.service';

@Component({
    selector: 'app-work-order',
    templateUrl: './work-order.component.html',
    styleUrls: ['./work-order.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class WorkOrderComponent implements OnInit {
	workOrderTypes: any[];
	isDataLoad = false;
	workOrderStatuses: any[];
	properties: any[]=[];
	housekeepingTypes: any[];
	salesManList: any[];
	checkInMinDate: Date;
	checkInMaxDate: Date;

	constructor(
		private reservationService: ReservationService,
		private primengConfig: PrimeNGConfig,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private propertyService: PropertyService,
		@Inject(MAT_DIALOG_DATA) data: any) {
			this.formTitle = data.title,
			this.workOrder = data.workOrder,
			this.reservation = data.reservation;
			this.workOrderTypes = this.reservationService.workOrderTypes;
			this.workOrderStatuses = this.reservationService.workOrderStatuses;
			this.housekeepingTypes = this.reservationService.housekeepingTypes;
			this.salesManList = this.reservationService.salesManList;
	}

	@Input() workOrder: any;
	@Input() reservation: any;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	workOrderId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'workOrderId': [],
		'workOrderType': [],
		'reservationId': [],
		workOrderStatus: [],
		changeLog:[],
		scheduledServiceDate: [],
		scheduledServiceDateTimeStart: [],
		scheduledServiceDateTimeStop: [],
		housekeepingType: [],
		privateNotes: [],
		guestNotes: [],
		technicianNotes: [],
		description: [],
		assignedToUserId: [],
		enteredByUserId: [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.fetchProperties();
		this.checkInMinDate = moment(this.reservation?.checkInDate).toDate();
		this.checkInMaxDate = new Date(this.checkInMinDate.getFullYear() + 3, this.checkInMinDate.getMonth(), this.checkInMinDate.getDate());

		// if we were passed the whole workOrder object
		if (this.workOrder) {
			this.workOrderId = this.workOrder.workOrderId;
			this.fixDates();
			this.form1.patchValue(this.workOrder);
			this.form1.patchValue({
				workOrderHousekeeping: {
					scheduledServiceDate: this.workOrder?.workOrderHousekeeping?.scheduledServiceDate != null ? moment(this.workOrder?.workOrderHousekeeping?.scheduledServiceDate).toDate() : null,
					scheduledServiceDateTimeStart: this.workOrder?.workOrderHousekeeping?.scheduledServiceDateTimeStart != null ? moment(this.workOrder?.workOrderHousekeeping?.scheduledServiceDateTimeStart).toDate() : null,
					scheduledServiceDateTimeStop: this.workOrder?.workOrderHousekeeping?.scheduledServiceDateTimeStop != null ? moment(this.workOrder?.workOrderHousekeeping?.scheduledServiceDateTimeStop).toDate() : null,
				},
			});
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.workOrderId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.reservationService.addWorkOrder(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.workOrder = res.data.workOrder;
						this.doAdd.emit(this.workOrder);
					},
					(err: any) => {
						console.log('workOrder-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('workOrder: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.reservationService.updateWorkOrder(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.workOrder = res.data.workOrder;
						this.doUpdate.emit(this.workOrder);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.reservationService.delete(this.workOrder.workOrderId)
				.subscribe(
					(res: any) => {
						console.log('workOrder-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.workOrder);
					},
					(err: any) => {
						console.log('workOrder-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			workOrderId: [this.workOrderId],
			shortTermRentalId:[this.reservation?.shortTermRental?.shortTermRentalId],
			workOrderType: [1],
			reservationId:[this.reservation?.reservationId],
			workOrderStatus:[1],
			changeLog:[],
			enteredByUserId: [0],
			workOrderName:["Departure Housekeeping"],
			createDate:[],
			
			workOrderHousekeeping: this.formBuilder.group({
				workOrderHousekeepingId:[this.workOrder?.workOrderHousekeeping?.workOrderHousekeepingId],
				housekeepingName:["Departure Housekeeping"],
				scheduledServiceDate: [moment(this.reservation?.checkInDate).toDate()],
				scheduledServiceDateTimeStart: [],
				scheduledServiceDateTimeStop: [],
				housekeepingType: [1],
				privateNotes: [],
				guestNotes: [],
				technicianNotes: [],
				description: [],
				assignedToUserId: [],
				createDate:[],
			}),


		});
		this.isDataLoad = true;
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.workOrder.workOrderDate = moment(this.workOrder.workOrderDate).toDate();
	}

	scheduledServiceDate(event: any){
		this.form1.value.scheduledServiceDate = event;
	}
	scheduledServiceDateTimeStart(event: any){
		this.form1.value.scheduledServiceDateTimeStart = event;
	}

	scheduledServiceDateTimeStop(event: any){
		this.form1.value.scheduledServiceDateTimeStop = event;
	}

	fetchProperties() {
		try {
			this.propertyService.findAllSummaryWithStatusActive()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
						
						return this.properties;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}
}